export const albumImages = [
  {
    original: '/img/20240720_185116.webp',
    thumbnail: '/img/20240720_185116.webp',
  },
  {
    original: '/img/20240724_191720.webp',
    thumbnail: '/img/20240724_191720.webp',
  },
  {
    original: '/img/20240806_095358.webp',
    thumbnail: '/img/20240806_095358.webp',
  },
  {
    original: '/img/20240807_100839.webp',
    thumbnail: '/img/20240807_100839.webp',
  },
  {
    original: '/img/Screenshot_20240704_120531_Chrome.webp',
    thumbnail: '/img/Screenshot_20240704_120531_Chrome.webp',
  },
  {
    original: '/img/20241010_160645.webp',
    thumbnail: '/img/20241010_160645.webp',
  },
  {
    original: '/img/20241108_165711.webp',
    thumbnail: '/img/20241108_165711.webp',
  },
  {
    original: '/img/20241207_131020.webp',
    thumbnail: '/img/20241207_131020.webp',
  },
  {
    original: '/img/20241207_131028.webp',
    thumbnail: '/img/20241207_131028.webp',
  },
];
